<script>
export default {
	name: 'Offer',
};
</script>

<template>
	<div class="container">
		<div class="offer">
			<h1 class="title fs-56 mb-40">Оферта о заключении договора на оказание платных услуг по подписке</h1>
			
			<div class="offer-content">
				<div class="fs-16 text-muted mb-30">
					<p>Российская Федерация, г. Всеволожск</p>
					<p>20.10.2024</p>
				</div>

				<p class="fs-18 mb-30">
					Настоящий документ представляет собой предложение Индивидуального предпринимателя Гаврилова Михаила Игоревича (далее – Исполнитель) заключить Договор на оказание платных услуг по подписке на изложенных ниже условиях.
				</p>

				<h2 class="fs-32 mb-20">1. ОПРЕДЕЛЕНИЯ И ТЕРМИНЫ</h2>
				<p class="fs-18 mb-20">
					1.1. В целях настоящего документа нижеприведенные термины используются в следующем значении:
				</p>
				<ul class="fs-18 mb-30">
					<li><strong>Исполнитель</strong> — Индивидуальный предприниматель Гаврилов Михаил Игоревич, ОГРНИП: 323784700149322, ИНН: 781156332638.</li>
					<li><strong>Пользователь</strong> — дееспособное физическое лицо, осуществившее акцепт Оферты, размещенной в Сервисе.</li>
					<li><strong>Стороны</strong> — Исполнитель и Пользователь.</li>
					<li><strong>Публичная оферта</strong> — публичное предложение Исполнителя, адресованное неопределенному кругу лиц, заключить с Исполнителем Договор на оказание платных услуг по подписке на условиях, содержащихся в настоящей Оферте.</li>
					<li><strong>Оферта</strong> — настоящий документ «Оферта о заключении договора на оказание платных услуг по подписке», размещенный в сети Интернет по адресу https://myvpn.com.</li>
					<li><strong>Подписка</strong> — предоставление Пользователю на условиях Договора возможность за плату заказать услуги Исполнителя через приложение "MyVPN".</li>
					<li><strong>Договор</strong> — договор возмездного оказания услуг по подписке между Пользователем и Исполнителем, который заключается посредством акцепта Оферты. Договор считается заключенным в письменной форме на основании положений п. 3 ст. 434, п. 3 ст. 438 ГК РФ.</li>
					<li><strong>Тариф</strong> – цена за подписку сроком на один месяц в приложении "MyVPN".</li>
					<li><strong>Сервис «Рекуррентный платеж»</strong> — сервис, позволяющий Исполнителю получать автоматические переводы денежных средств с Банковских карт Пользователя.</li>
					<li><strong>Банк</strong> — кредитная организация, осуществляющая выпуск Банковских карт на территории Российской Федерации в соответствии с законодательством Российской Федерации и на основании договоров, заключенных между Банком и Клиентом.</li>
					<li><strong>Банковская карта</strong> — расчетная или кредитная карта, эмитентом которой является кредитная организация, являющаяся инструментом безналичных расчетов, предназначенная для совершения Клиентами Банка операций с денежными средствами, находящимися у Банка на банковских счетах Клиентов Банка или с денежными средствами, предоставленными Банком в кредит Клиентам Банка в соответствии с законодательством Российской Федерации, а также договором банковского счёта, или в пределах установленного лимита, в соответствии с условиями кредитного договора между Банком и Клиентом Банка, при условии, что такая расчетная или кредитная карта может быть использована для оплаты Услуг Исполнителя. Оплата Услуг Исполнителя в соответствии с настоящим Договором возможна Банковскими картами зарегистрированными в соответствии с действующим законодательством Российской Федерации.</li>
					<li><strong>Процессинговый центр</strong> — автоматизированная система обработки транзакций по Банковским картам в сфере электронной коммерции, предоставляющая возможность принятия платежей по Банковским картам. Процессинговый центр координирует расчеты между Банком-эмитентом карты, Банком-эквайером (осуществляющим авторизацию транзакций), Сервисом «Рекуррентный платеж» и Клиентом Банковской карты.</li>
					<li><strong>Держатель карты</strong> – физическое лицо, дающее распоряжение Банку-эмитенту на перевод денежных средств с Банковской карты от имени Пользователя в пользу Исполнителя с помощью Сервиса «Рекуррентный платеж».</li>
					<li><strong>Персональные данные</strong> — любая информация, относящаяся прямо или косвенно к определенному или определяемому физическому лицу (субъекту персональных данных).</li>
				</ul>

				<p class="fs-18 mb-20">
					1.2. В Оферте могут быть использованы термины, не определенные в п. 1.1. Оферты. В этом случае толкование такого термина производится в соответствии с текстом Оферты. В случае отсутствия однозначного толкования термина в тексте Оферты следует руководствоваться толкованием термина, определенным: в первую очередь — применимыми документами, во вторую очередь — законодательством РФ, в третью очередь — в соответствии с информацией на интернет-сайте, затем - сложившимся (общеупотребимым) в сети Интернет.
				</p>

				<h2 class="fs-32 mb-20">2. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
				<p class="fs-18 mb-20">
					2.1. Пользователь осуществляет подписку в приложении "MyVPN". Оплатой Заказа Пользователь подтверждает согласие на заключение настоящего Договора (акцепт оферты).
				</p>
				<p class="fs-18 mb-20">
					2.2. Заключая Договор, Пользователь подтверждает следующее:
				</p>
				<ul class="fs-18 mb-30">
					<li>2.2.1. Целиком и полностью ознакомлен, и согласен с условиями настоящего Договора.</li>
					<li>2.2.2. Дает разрешение на сбор, обработку и передачу персональных данных на условиях, определенных в Политике конфиденциальности, размещенной на интернет-сайте: https://myvpn.tech.</li>
					<li>2.2.3. Пользователь дает разрешение на присоединение к системе рекуррентных платежей на условиях, определенных настоящей Офертой на оказание платных услуг по подписке и размещенной по адресу: https://myvpn.tech.</li>
				</ul>

				<h2 class="fs-32 mb-20">3. СТОИМОСТЬ УСЛУГ И ПОРЯДОК РАСЧЕТОВ</h2>
				<p class="fs-18 mb-20">
					3.1 Тарифы на подписки:
				</p>
				<ul class="fs-18 mb-20">
					<li>Подписка на неделю — 99 руб./неделя.</li>
					<li>Подписка на месяц — 399 руб./месяц.</li>
					<li>Подписка на год — 2490 руб./год.</li>
				</ul>

				<h2 class="fs-32 mb-20">4. ОФОРМЛЕНИЕ ЗАКАЗА</h2>
				<p class="fs-18 mb-20">
					4.1. Заказ Услуги осуществляется Пользователем через приложение "MyVPN".
				</p>
				<p class="fs-18 mb-20">
					4.4. Договор между Исполнителем и Пользователем считается заключенным с момента электронного оформления заказа и его оплаты Пользователем.
				</p>
				<p class="fs-18 mb-20">
					4.5. При оформлении заказа Пользователь автоматически дает разрешение на присоединение к системе рекуррентных платежей.
				</p>

				<h2 class="fs-32 mb-20">5. ПРЕКРАЩЕНИЕ ОКАЗАНИЯ УСЛУГ</h2>
				<p class="fs-18 mb-20">
					5.1. Пользователь вправе отказаться от услуги в любое время действия Договора, средства, уплаченные в соответствии с тарифами до момента отказа от услуги, возврату не подлежат.
				</p>
				<p class="fs-18 mb-20">
					5.2. Отмена подписки возможна путем обращения в Техническую поддержку с помощью команды в Телеграм-боте.
				</p>

				<h2 class="fs-32 mb-20">6. ОТВЕТСТВЕННОСТЬ СТОРОН</h2>
				<p class="fs-18 mb-20">
					6.1. За неисполнение или ненадлежащее исполнение обязательств по настоящему Договору Стороны несут ответственность в соответствии с настоящим Договором и действующим законодательством Российской Федерации.
				</p>

				<h2 class="fs-32 mb-20">7. СРОК ДЕЙСТВИЯ ДОГОВОРА И ПРИЕМКА ОКАЗАННЫХ УСЛУГ</h2>
				<p class="fs-18 mb-20">
					7.1. Если в течении 3 календарных дней с даты окончания календарного месяца от Пользователя не поступили претензии по оказанной услуге, то услуга считается оказанной Исполнителем и принятой Пользователем надлежащим образом.
				</p>

				<h2 class="fs-32 mb-20">8. ИНЫЕ УСЛОВИЯ</h2>
				<p class="fs-18 mb-20">
					8.1. Настоящий Договор действует до полного исполнения Сторонами принятых на себя обязательств.
				</p>
				<p class="fs-18 mb-20">
					8.2. Все споры, разногласия и претензии, которые могут возникнуть в связи с использованием приложения "MyVPN" и оказанием Услуги, подлежат урегулированию в претензионном порядке. Сторона, считающая свои права нарушенными, направляет другой стороне по адресу электронной почты претензию с указанием возникших разногласий. Если спор не будет урегулирован в течение 10 рабочих дней с момента получения стороной претензии, спор передается в суд Российской Федерации согласно подсудности дел, определенной законодательством Российской Федерации по месту нахождения Исполнителя.
				</p>

				<h2 class="fs-32 mb-20">9. ПЕРСОНАЛЬНЫЕ ДАННЫЕ</h2>
				<p class="fs-18 mb-20">
					9.1. Исполнитель обязуется обрабатывать персональную информацию Пользователя, полученную им в рамках оказания Услуг по Подписке, в соответствии с требованиями Федерального закона «О персональных данных» от 27.07.2006 № 152-ФЗ.
				</p>

				<h2 class="fs-32 mb-20">10. РЕКВИЗИТЫ ИСПОЛНИТЕЛЯ:</h2>
				<div class="fs-18 mb-30">
					<p><strong>Индивидуальный предприниматель Гаврилов Михаил Игоревич</strong></p>
					<p>ОГРНИП: 323784700149322, ИНН: 781156332638</p>
					<p>Адрес электронной почты: info@myvpn.com</p>
					<p>Веб-сайт: https://web.myvpn5.com</p>
					<p>Банковские реквизиты:</p>
					<p>БИК: 044525974</p>
					<p>Название банка: АО "ТБанк"</p>
					<p>Корр. счет: 30101810145250000974</p>
					<p>Расчетный счет: 40802810600004664829</p>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.offer {
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
}

.offer-content {
	line-height: 1.6;
}

.offer-content ul {
	padding-left: 20px;
}

.offer-content li {
	margin-bottom: 10px;
}

.text-muted {
	color: #A6ADB8;
}
</style>
